export default __webpack_public_path__ + "static/media/pagePhoto1.19c33e58.png";